import { ReactNode } from 'react';
import { Options } from '@contentful/rich-text-react-renderer';
import { AccordionBlock } from '@graphql/__generated__/graphql';
import { AccordionBlockProps, UseServer } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { AccordionSection, DocumentLinks, Theme } from '@stadionhq-v3/core';
import ContentfulRichTextRenderer from '@components/helpers/contentful-rich-text-render';
import { Translations } from '@lib/dictionary-keys/__generated__';
import { StreamVideoAndOverlayWrapperDictionary } from '@components/helpers/stream-video-and-overlay-wrapper';

export type AccordionBlockTransformSettings = {
  richTextRenderOptions?: Options;
};

const accordionBlockTransform = (
  {
    id,
    title,
    subtitle,
    introParagraph,
    theme,
    bodyCopy,
    accordionSections,
  }: CleanContentful<AccordionBlock>,
  dictionary: Pick<Translations['common']['action'], 'next' | 'previous'> &
    StreamVideoAndOverlayWrapperDictionary,
  themeOverride?: Theme
): AccordionBlockProps => ({
  id,
  title,
  subtitle,
  introParagraph,
  theme: themeOverride || (theme as Theme) || undefined,
  bodyCopy: bodyCopy && (
    <UseServer>
      <ContentfulRichTextRenderer
        document={{
          json: bodyCopy?.json,
          links: bodyCopy?.links as DocumentLinks,
        }}
        dictionary={dictionary}
        theme={themeOverride || (theme as Theme) || undefined}
      />
    </UseServer>
  ),
  accordionSections: accordionSections?.map((item) => ({
    id: item?.id,
    title: item?.title,
    assistiveText: item?.assistiveText,
    content: (
      <UseServer>
        <ContentfulRichTextRenderer
          theme={themeOverride || (theme as Theme) || undefined}
          document={{
            json: item.content?.json,
            links: item.content?.links as DocumentLinks,
          }}
          dictionary={dictionary}
        />
      </UseServer>
    ),
  })) as AccordionSection<ReactNode>[],
});

export default accordionBlockTransform;
